import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Checkbox } from 'rmwc/Checkbox';
import { List, ListItem, ListItemText, ListItemMeta } from 'rmwc';
import { Text } from '../../components/Text';
import { DynamicWrapper } from '../../components/util/DynamicWrapper';
import { backOnboarding, continueOnboarding, pathAware } from '../../actions/onboardingActions';

class LifeChanges extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lifeChangeMarriage: props.qna_hash.lifeChangeMarriage ? props.qna_hash.lifeChangeMarriage.answer : false,
      lifeChangeDivorce: props.qna_hash.lifeChangeDivorce ? props.qna_hash.lifeChangeDivorce.answer : false,
      lifeChangeChild: props.qna_hash.lifeChangeChild ? props.qna_hash.lifeChangeChild.answer : false,
      lifeChangeIllness: props.qna_hash.lifeChangeIllness ? props.qna_hash.lifeChangeIllness.answer : false,
      lifeChangeCareer: props.qna_hash.lifeChangeCareer ? props.qna_hash.lifeChangeCareer.answer : false,
      lifeChangeRelocation: props.qna_hash.lifeChangeRelocation ? props.qna_hash.lifeChangeRelocation.answer : false,
    };
  }

  componentDidMount() {
    this.props.pathAware('lifeChangeMarriage');
  }

  componentWillReceiveProps(props) {
    if (props.qna_hash.lifeChangeMarriage) {
      this.setState({
        lifeChangeMarriage: props.qna_hash.lifeChangeMarriage.answer,
        lifeChangeDivorce: props.qna_hash.lifeChangeDivorce.answer,
        lifeChangeChild: props.qna_hash.lifeChangeChild.answer,
        lifeChangeCareer: props.qna_hash.lifeChangeCareer.answer,
        lifeChangeRelocation: props.qna_hash.lifeChangeRelocation.answer,
      });
    }
  }

  _onContinue = () => {
    const { onContinue, qna_hash, qna_stack } = this.props;
    const {
      lifeChangeMarriage,
      lifeChangeDivorce,
      lifeChangeChild,
      lifeChangeIllness,
      lifeChangeCareer,
      lifeChangeRelocation,
    } = this.state;

    this.props
      .continueOnboarding(qna_stack, qna_hash, {
        lifeChangeMarriage: {
          question: 'Did you recently or are you about to get married?',
          answer: lifeChangeMarriage,
        },
        lifeChangeDivorce: {
          question: 'Did you recently or are you about to get divorced?',
          answer: lifeChangeDivorce,
        },
        lifeChangeChild: {
          question: 'Did you recently or are you about to have a child?',
          answer: lifeChangeChild,
        },
        lifeChangeIllness: {
          question: 'Did you recently have a major illness?',
          answer: lifeChangeIllness,
        },
        lifeChangeCareer: {
          question: 'Did you recently or are you about to change careers?',
          answer: lifeChangeCareer,
        },
        lifeChangeRelocation: {
          question: 'Did you recently or are you about to move/relocate?',
          answer: lifeChangeRelocation,
        },
      })
      .then(onContinue);
  };

  _onBack = () => {
    this.props.backOnboarding(this.props.qna_stack).then(() => this.props.onBack());
  };

  onChange = (evt, field) => {
    this.setState({ [field]: !this.state[field] });
  };

  checkboxRow = option => {
    const selected = this.state[option.field];

    return (
      <ListItem
        id={option.field}
        theme={selected && 'secondary'}
        key={option.field}
        selected={selected}
        onClick={e => this.onChange(e, option.field)}
      >
        <div style={{ display: 'flex', alignItems: 'center', width: '350px' }}>
          <img src={option.icon} height={40} />
          <ListItemText className="ml-3">{option.title}</ListItemText>
        </div>

        <ListItemMeta theme={selected && 'secondary'} className="hrbr-clickable">
          {selected ? 'check_box' : 'check_box_outline_blank'}
        </ListItemMeta>
      </ListItem>
    );
  };

  render() {
    const { qna_hash, wrapper } = this.props;

    const {
      lifeChangeMarriage,
      lifeChangeDivorce,
      lifeChangeChild,
      lifeChangeIllness,
      lifeChangeCareer,
      lifeChangeRelocation,
    } = this.state;

    const options = [
      { icon: require('images/rings'), title: 'Marriage', field: 'lifeChangeMarriage' },
      { icon: require('images/divorce'), title: 'Divorce', field: 'lifeChangeDivorce' },
      { icon: require('images/baby'), title: 'Having a child', field: 'lifeChangeChild' },
      { icon: require('images/illness'), title: 'Major illness', field: 'lifeChangeIllness' },
      { icon: require('images/career'), title: 'Career change/Retirement', field: 'lifeChangeCareer' },
      { icon: require('images/moving'), title: 'Moving/Relocation', field: 'lifeChangeRelocation' },
    ];

    return (
      <DynamicWrapper
        style={{ width: '100%' }}
        wrapper={wrapper}
        onContinue={this._onContinue}
        onBack={this._onBack}
        canContinue
      >
        <div style={{ width: '90%', display: 'flex', justifyContent: 'center' }}>
          <Text use="headline6">Any recent or upcoming life changes?</Text>
        </div>
        <div style={{ width: '100%' }}>
          <Text use="body1" className="ml-4 mr-4">
            Please select any that might impact your financial plans. Many clients come to us specifically for help
            managing these important life changes.
          </Text>
        </div>
        <List twoLine>{options.map(this.checkboxRow)}</List>
      </DynamicWrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    qna_hash: state.onboarding.qna_hash,
    qna_stack: state.onboarding.qna_stack,
  };
}

export default connect(mapStateToProps, { backOnboarding, continueOnboarding, pathAware })(LifeChanges);
